(function () {
    'use strict';

    angular.module("newCustomerApp", ["common.routes", "common.baseurl", "common.routes.helper", "common.appversion",
        "pascalprecht.translate", "ui-notification", "ngSanitize", "ui.bootstrap.modal", "ui.bootstrap.tpls"])
        .config(translateConfig)
        .run(['$translate', function ($translate) {
            $translate.refresh();
        }]);

})();

